'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ResizeHandle = require('../views/elements/ResizeHandle');

var _ResizeHandle2 = _interopRequireDefault(_ResizeHandle);

var _resizer = require('../../resizer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MainSplit = function (_React$Component) {
    (0, _inherits3.default)(MainSplit, _React$Component);

    function MainSplit(props) {
        (0, _classCallCheck3.default)(this, MainSplit);

        var _this = (0, _possibleConstructorReturn3.default)(this, (MainSplit.__proto__ || (0, _getPrototypeOf2.default)(MainSplit)).call(this, props));

        _this._setResizeContainerRef = _this._setResizeContainerRef.bind(_this);
        _this._onResized = _this._onResized.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(MainSplit, [{
        key: '_onResized',
        value: function _onResized(size) {
            window.localStorage.setItem("mx_rhs_size", size);
        }
    }, {
        key: '_createResizer',
        value: function _createResizer() {
            var classNames = {
                handle: "mx_ResizeHandle",
                vertical: "mx_ResizeHandle_vertical",
                reverse: "mx_ResizeHandle_reverse"
            };
            var resizer = new _resizer.Resizer(this.resizeContainer, _resizer.FixedDistributor, { onResized: this._onResized });
            resizer.setClassNames(classNames);
            var rhsSize = window.localStorage.getItem("mx_rhs_size");
            if (rhsSize !== null) {
                rhsSize = parseInt(rhsSize, 10);
            } else {
                rhsSize = 350;
            }
            resizer.forHandleAt(0).resize(rhsSize);

            resizer.attach();
            this.resizer = resizer;
        }
    }, {
        key: '_setResizeContainerRef',
        value: function _setResizeContainerRef(div) {
            this.resizeContainer = div;
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.panel && !this.props.collapsedRhs) {
                this._createResizer();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.resizer) {
                this.resizer.detach();
                this.resizer = null;
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var wasExpanded = !this.props.collapsedRhs && prevProps.collapsedRhs;
            var wasCollapsed = this.props.collapsedRhs && !prevProps.collapsedRhs;
            var wasPanelSet = this.props.panel && !prevProps.panel;
            var wasPanelCleared = !this.props.panel && prevProps.panel;

            if (wasExpanded || wasPanelSet) {
                this._createResizer();
            } else if (wasCollapsed || wasPanelCleared) {
                this.resizer.detach();
                this.resizer = null;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var bodyView = _react2.default.Children.only(this.props.children);
            var panelView = this.props.panel;

            if (this.props.collapsedRhs || !panelView) {
                return bodyView;
            } else {
                return _react2.default.createElement(
                    'div',
                    { className: 'mx_MainSplit', ref: this._setResizeContainerRef },
                    bodyView,
                    _react2.default.createElement(_ResizeHandle2.default, { reverse: true }),
                    panelView
                );
            }
        }
    }]);
    return MainSplit;
}(_react2.default.Component); /*
                              Copyright 2018 New Vector Ltd
                              
                              Licensed under the Apache License, Version 2.0 (the "License");
                              you may not use this file except in compliance with the License.
                              You may obtain a copy of the License at
                              
                                  http://www.apache.org/licenses/LICENSE-2.0
                              
                              Unless required by applicable law or agreed to in writing, software
                              distributed under the License is distributed on an "AS IS" BASIS,
                              WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                              See the License for the specific language governing permissions and
                              limitations under the License.
                              */

exports.default = MainSplit;
module.exports = exports['default'];
//# sourceMappingURL=MainSplit.js.map